import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { FaArrowLeft } from "react-icons/fa"; // Removed unused FaFilePdf import
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { fetchCustomerInvoice } from "../../store/Slices/CustomerInvoiceSlice";
import InvoicePDF from "./InvoicePDF"; // Ensure InvoicePDF is correctly exported
import { useReactToPrint } from "react-to-print";
import { fetchSuppliers } from "../../store/Slices/SupplierSlice";
import { CustomerCompleteLedgerColumns } from "../../assets/Columns/CustomerCompleteLedgerColumns";
import { fetchProducts } from "../../store/Slices/ProductSlice";
import { fetchCustomers } from "../../store/Slices/CustomerSlice";
import { fetchCustomerLedger } from "../../store/Slices/CustomerLedgerSlice";
import { CustomerItemSummaryColumns } from "../../assets/Columns/CustomerItemSummaryColumns";
import { fetchCustomerItemSummary } from "../../store/Slices/CustomerItemSummarySlice";
import FigureCard from "../Cards/FigureCard";
import { fetchCompanyItemSummary } from "../../store/Slices/CompanyItemSummarySlice";
import DetailsCard from "../Cards/DetailsCard";
import ThermalItemSummary from "./ThermalItemSummary";
import ThermalPrintHost from "../Thermal/ThermalPrintHost";
import { mapItemSummaryToThermalReceipt } from "../../utils/thermalReceipt";
import { THERMAL_WIDTH_MM } from "../Thermal/thermalConfig";
import { formatDateTime } from "../../utils/dateTime";

const CompanyItemSummaryReport = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const CustomerLedgers = useSelector((state) => state.CustomerLedgers);
  const CompanyItemSummaryState = useSelector(
    (state) => state.CompanyItemSummaryState
  );

  const Suppliers = useSelector((state) => state.Suppliers);

  useEffect(() => {
    dispatch(fetchSuppliers());
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(fetchCompanyItemSummary(id));
    }
  }, [id]);

  const thermalPrintRef = useRef(null);
  const [thermalPrintData, setThermalPrintData] = useState(null);
  const printPendingRef = useRef(false);

  const supplierRecord = Suppliers?.data?.find((dt) => dt._id === id);

  const buildThermalSummaryData = useCallback(() => {
    return mapItemSummaryToThermalReceipt({
      title: "Company Item Summary",
      partyLabel: "Company",
      partyName: supplierRecord?.name || "",
      partyContact: supplierRecord?.contact || "",
      partyAddress: supplierRecord?.address || "",
      tabLabel: "All",
      rows: CompanyItemSummaryState?.data || [],
      footer: {
        totalAmount: supplierRecord?.total,
        paid: supplierRecord?.paid,
        remaining: supplierRecord?.payable,
      },
    });
  }, [supplierRecord, CompanyItemSummaryState?.data]);

  const handleThermalPrint = useReactToPrint({
    content: () => thermalPrintRef.current,
    documentTitle: `CompanySummary-${supplierRecord?.name || id}`,
    removeAfterPrint: true,
    onAfterPrint: () => {
      printPendingRef.current = false;
    },
  });

  useEffect(() => {
    if (!printPendingRef.current || !thermalPrintData) return;
    printPendingRef.current = false;
    const timer = setTimeout(() => handleThermalPrint(), 350);
    return () => clearTimeout(timer);
  }, [thermalPrintData, handleThermalPrint]);

  const AmountTitleConverter = (amoutTitle) => {
    console.log(amoutTitle);

    switch (amoutTitle) {
      case "Payable":
        return "Remaining";
      case "Paid":
        return "Paid";
      case "Total":
        return "Total";
      default:
        return amoutTitle;
    }
  };

  const [CurrentTab, setCurrentTab] = useState("All");

  const CurrentData =
    CurrentTab === "All"
      ? CustomerLedgers.data.All
      : CurrentTab === "Item"
      ? CustomerLedgers.data.Item
      : CurrentTab === "Cash"
      ? CustomerLedgers.data.Cash
      : [];

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="mt-[12vh] flex items-center justify-center gap-x-3 relative w-full mb-10">
        <div
          className="border-2 border-ink px-2 py-2 rounded-full hover:text-white hover:bg-ink transition-colors ease-in-out duration-200 cursor-pointer absolute top-0 left-5"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft />
        </div>
        <button
          type="button"
          className="px-2 py-2 border-2 border-main bg-main text-white hover:rounded-lg cursor-pointer w-[220px] flex justify-center items-center font-bold my-3"
          onClick={() => {
            printPendingRef.current = true;
            setThermalPrintData(buildThermalSummaryData());
          }}
        >
          Print {THERMAL_WIDTH_MM}mm Thermal
        </button>
      </div>

      <div className="flex flex-col w-auto p-2 max-w-5xl">
        <img
          src={`/banner.jpeg`}
          alt="banner"
          className="w-[100%] h-auto border-2 border-[#002650] rounded-t-lg"
        />

        <div className="flex w-full bg-main text-white justify-center items-center py-2 font-bold text-xl px-3 font-quicksand mt-1">
          Company Details
        </div>

        <div className="grid grid-cols-3 border-2 border-main rounded-none">
          <DetailsCard
            title={"Name"}
            value={Suppliers.data.find((dt) => dt._id === id)?.name || ""}
          />
          <DetailsCard
            title={"Contact"}
            value={Suppliers.data.find((dt) => dt._id === id)?.contact || ""}
          />
          <DetailsCard
            title={"Address"}
            value={Suppliers.data.find((dt) => dt._id === id)?.address || ""}
          />
        </div>

        {/* customer details */}
        <div className="flex w-full bg-main text-white justify-center items-center py-2 font-bold text-xl px-3 font-quicksand mt-1">
          Comapny Item Summary
        </div>

        {/* Invoice Items Table */}
        {CompanyItemSummaryState?.data && (
          <div className="w-full overflow-x-auto mt-1">
            <table className="w-full text-left border-collapse border border-main">
              <thead className="bg-main text-white">
                <tr>
                  {CustomerItemSummaryColumns.filter(
                    (dt) => dt.id !== "actions" && dt.id !== "description"
                  ).map((dt, ci) => {
                    return (
                      <th
                        className={`border border-main px-3 py-2 whitespace-nowrap ${
                          ci === 0
                            ? "flex-1"
                            : ci === 1
                            ? "w-[120px]"
                            : ci === 2
                            ? "w-[120px]"
                            : ci === 3
                            ? "w-[120px]"
                            : "w-[120px]"
                        }`}
                      >
                        {["payable", "paid", "total"].includes(dt.id)
                          ? AmountTitleConverter(dt.title)
                          : dt.id === "price"
                          ? "Price"
                          : dt.title}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {CompanyItemSummaryState.data.map((item, index) => {
                  const isLastRow =
                    index === CompanyItemSummaryState.data.length - 1;

                  return (
                    <tr
                      key={index}
                      className={`text-main ${
                        isLastRow ? "bg-main text-white font-bold" : ""
                      }`}
                    >
                      {CustomerItemSummaryColumns.filter(
                        (dt) => dt.id !== "actions" && dt.id !== "description"
                      ).map((dt, i) => (
                        <td
                          key={i}
                          className={`border border-main px-3 py-2 ${
                            ["payable", "paid", "total"].includes(dt.id)
                              ? "font-bold"
                              : ""
                          } ${isLastRow ? "text-white" : ""}`}
                        >
                          {[
                            "payable",
                            "cr",
                            "dr",
                            "price",
                            "paid",
                            "total",
                          ].includes(dt.id)
                            ? `${Number(item[dt.id]).toLocaleString("en-PK")}`
                            : dt.id === "companyId"
                            ? item.companyId.name
                            : dt.id === "date"
                            ? formatDateTime(item[dt.id])
                            : item[dt.id]}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        <div className="mt-6 grid grid-cols-3 gap-4">
          <div className="bg-card p-4 rounded-2xl border border-line shadow-soft">
            <h3 className="text-muted text-sm font-medium">Total Amount</h3>
            <p className="text-2xl font-bold text-ink">
              Rs{" "}
              {Suppliers.data
                .find((dt) => {
                  return dt._id === id;
                })
                ?.total.toLocaleString()}
            </p>
          </div>
          <div className="bg-card p-4 rounded-2xl border border-line shadow-soft">
            <h3 className="text-muted text-sm font-medium">Total Paid</h3>
            <p className="text-2xl font-bold text-success">
              Rs{" "}
              {Suppliers.data
                .find((dt) => {
                  return dt._id === id;
                })
                ?.paid.toLocaleString()}
            </p>
          </div>
          <div className="bg-card p-4 rounded-2xl border border-line shadow-soft">
            <h3 className="text-muted text-sm font-medium">Total Payable</h3>
            <p className="text-2xl font-bold text-danger">
              Rs{" "}
              {Suppliers.data
                .find((dt) => {
                  return dt._id === id;
                })
                ?.payable.toLocaleString()}
            </p>
          </div>
        </div>
      </div>

      <ThermalPrintHost
        data={thermalPrintData}
        printRef={thermalPrintRef}
        component={ThermalItemSummary}
      />
    </div>
  );
};

export default CompanyItemSummaryReport;
